import readingTime from "lib/reading-time";

export default function ReadingTime({ post, className = "" }) {
  return (
    <span className={` ${className ? className : "font-medium text-gray-500 text-sm"}`}>
      {readingTime(post, { minute: "1 minute read", minutes: "% minute read" })}
    </span>
  );
}
